import { keycloakUtils } from "itsf-ui-common";
import { updateTermsAndConditionRouteAcquisitionProspect } from "./acquisitionProspects";
import { updateTermsAndConditionRouteCrossSell } from "./crossSell";

export const updateTermsAndConditionRoute = () =>
    keycloakUtils.isAuthenticated()
        ? updateTermsAndConditionRouteCrossSell()
        : updateTermsAndConditionRouteAcquisitionProspect();
